module.exports = __webpack_public_path__ + "img/clic_pub_rec_960.2f98076c.png";